import { StateUtils } from '@spartacus/core';
import { PHONE } from '../main-phone-state';

export const LOAD_PHONE = '[Main] Phone Load';
export const LOAD_PHONE_SUCCESS = '[Main] Phone Load Success';
export const LOAD_PHONE_FAIL = '[Main] Phone Load Fail';

export class PhoneLoad extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_PHONE;

  // payload - код города
  constructor(public payload: string) {
    super(PHONE);
  }
}

export class PhoneLoadFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_PHONE_FAIL;

  constructor(public payload: any) {
    super(PHONE, payload);
  }
}

export class PhoneLoadSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_PHONE_SUCCESS;

  constructor(public payload: string) {
    super(PHONE);
  }
}

export type PhoneLoadAction = PhoneLoad | PhoneLoadFail | PhoneLoadSuccess;
